import { byId } from './lib/dom';
import { renderNav } from './components/nav';
import { renderCategoryFilter } from './components/category-filter';
import { renderItemsTable } from './components/items-table';
import type { ListItemsParams } from './lib/api';

/**
 * App entry point. Wires components together and owns the filter state.
 *
 * State pattern: a single `filters` object holds the current view state.
 * Any change calls `applyFilters()`, which re-renders the table. Components
 * stay dumb — they don't know about each other.
 */

const filters: ListItemsParams = {
  category: undefined,
  status: undefined,
  limit: 50,
};

function applyFilters() {
  renderItemsTable(byId('items-table'), filters);
}

async function main() {
  // Footer year
  byId('year').textContent = String(new Date().getFullYear());

  // Nav
  renderNav(byId('nav'));

  // Filters → trigger re-render
  await renderCategoryFilter(byId<HTMLSelectElement>('category-filter'), {
    onChange: (value) => {
      filters.category = value || undefined;
      applyFilters();
    },
  });

  byId<HTMLSelectElement>('status-filter').addEventListener('change', (e) => {
    const value = (e.target as HTMLSelectElement).value;
    filters.status = value || undefined;
    applyFilters();
  });

  // Initial render
  applyFilters();
}

main().catch((err) => {
  console.error('App failed to start:', err);
});
